import React, {Fragment} from 'react'
import 'antd/dist/antd.css';
import './ContactForm.css';
import { Form, Input, Row, Col, Button } from 'antd';
const { TextArea } = Input;

class ContactForm extends React.Component {
  
  state = {
    myname:'',
    email:'',
    company:'',
    message:'',
    status:''
  };
  
  handleSubmit = (e) => {
    // front-end validation here

    

    var name = this.state.myname;
    var email = this.state.email;
    var company = this.state.company;

    if (this.props.myMsg){
      var message = 'Remote RX Contact Form Request - ' + this.state.message;
    } else {
      var message = this.state.message;
    }

    console.log(message);
    
    const validateEmail = (email,name) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)===false){
        alert('Please fill out the Email field correctly');
        return false;
      }
      if(name === ''){
        alert('Please fill out the Name field correctly');
        return false;
      }

      return true;
    }

    

    // alert(`
    //   Form Data Submitted - Thanks! 
    //   ${this.state.myname} 
    //   ${this.state.email} 
    //   ${this.state.company} 
    //   ${this.state.message}
    //   `);
      
    if (validateEmail(email,name)===true){

      var payload =  JSON.stringify({"name":name, "email":email, "company":company, "message":message});

      fetch('https://www.realtimetouch.com/processform', {
              method: 'post',
              headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
              },
              body: payload
              })
              .then(res=>res.json())
              // .then(res=>res)
              .then(res => {
                // console.log(res);
                if(res.status==='success'){
                  this.setState(prevState => ({status: 'success'}));
                  // return alert('Form info received and processed by server');
                } else {
                  return alert('Error- email not sent, check with admin');
                }
              });

    }
  }

  handleChangeName = (e) => {
    this.setState({myname: e.target.value});
  }

  handleChangeEmail = (e) => {
    this.setState({email: e.target.value});
  }

  handleChangeCompany = (e) => {
    this.setState({company: e.target.value});
  }

  handleChangeMessage = (e) => {
    this.setState({message: e.target.value});
  }


  render() {
    // console.log(this.state.myname);
    // console.log(this.state.company);
    // console.log(this.state.email);
    // console.log(this.state.message);
    
    
    var buttonMsg = this.props.buttonMsg || 'Contact Real Time Touch';
    

    

    if(this.state.status==='success' ) {
      return(
        <div className="ContactForm--container">
          <div className="ContactForm--success">
            <h3>Form Successfully Mailed</h3>
            <h4>Thank you for contacting us.</h4>
            <h5>We will respond to your inquiry with 24 hours.</h5>
            <h5>Sincerely,</h5>
            <h5>Real Time Touch staff</h5>
          </div>
        </div>
      );
    } else {
      return(
        <Fragment>
          <div className="ContactForm--container">
            {/* <Form onSubmit={this.handleSubmit}>
              <Row className="ContactForm--formRow">
                <Col className="ContactForm--formCol" sm={24} md={6} >
                <label name="myname">Name</label>
                </Col>
                <Col className="ContactForm--formCol" sm={24}md={18} >
                  <Input id="myname" type="text" size="large" placeholder="Name" value={this.state.myname} onChange={this.handleChangeName.bind(this)} />
                </Col>
              </Row>
              <Row className="ContactForm--formRow">
                <Col className="ContactForm--formCol" sm={24} md={6} >
                <label name="email">Email</label>
                </Col>
                <Col className="ContactForm--formCol" sm={24}md={18} >
                  <Input id="email" type="text" size="large" placeholder="example@gmail.com" value={this.state.email} onChange={this.handleChangeEmail.bind(this)}  />
                </Col>
              </Row>
              <Row className="ContactForm--formRow">
                <Col className="ContactForm--formCol" sm={24} md={6} >
                  <label name="company">Company</label>
                </Col>
                <Col className="ContactForm--formCol" sm={24}md={18} >
                  <Input id="company" type="text" size="large" placeholder="Company" value={this.state.company} onChange={this.handleChangeCompany.bind(this)}  />
                </Col>
              </Row>
              <Row className="ContactForm--formRow">
                <Col className="ContactForm--formCol" sm={24} md={6} >
                  <label name="message">Message</label>
                </Col>
                <Col className="ContactForm--formCol" sm={24}md={18} >
                  <TextArea rows={4} size="large" placeholder="Your message" value={this.state.message} onChange={this.handleChangeMessage.bind(this)} ></TextArea> 
                </Col>
              </Row>
              <Row className="ContactForm--formRow" style={{marginTop: 40}}>
                <Col className="ContactForm--formCol" sm={24} md={6} >
                </Col>
                <Col className="ContactForm--formCol" sm={24}md={18} >
                </Col>
              </Row>
              <Row className="ContactForm--formRow" style={{marginTop: 10}}>
                <Col className="ContactForm--formCol" sm={24} md={6} >
                </Col>
                <Col className="ContactForm--formCol" sm={24}md={18} >
                  <Button className="ContactForm--submitButton" onClick={this.handleSubmit} size="large" type="primary">{buttonMsg}</Button>
                  <p className="ContactForm--contactMsgLower" style={{color:'gray'}}>You can also contact Real Time Touch founder Craig Linden at rtt.craig@yahoo.com</p>
                </Col>
              </Row>
              <Row className="ContactForm--formRow">
                <Col className="ContactForm--formCol" sm={24} >
                
                </Col>
              </Row>
            </Form> */}
          </div>
        </Fragment>
      ); 
    }
  }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/common/ContactForm/ContactForm.js